import { Map, fromJS, List } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    cards: List([]),
    cardLinkedToSubscription: null,
    isCardProcessing: false,
    isPaypalProcessing: false,
    getCardsInProgress: false,
    cardProcessingError: null,
    selectedCard: null,
    defaultCard: null,
    lastSubscriptionRenewalDate: null,
})
const wallet = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.ADD_CARD: {
            return state.merge({
                cardProcessingError: null,
                isCardProcessing: true,
            })
        }

        case actions.ADD_CARD_SUCCESS: {
            return state.merge({
                cardProcessingError: null,
                isCardProcessing: false,
            })
        }

        case actions.ADD_CARD_FAILED: {
            return state.merge({
                isCardProcessing: false,
                cardProcessingError: fromJS(payload.errorMessage),
            })
        }

        case actions.REMOVE_CARD: {
            return state.merge({
                cardProcessingError: null,
                isCardProcessing: true,
            })
        }

        case actions.REMOVE_CARD_SUCCESS: {
            return state.merge({
                isCardProcessing: false,
                cardProcessingError: null,
            })
        }

        case actions.REMOVE_CARD_FAILED: {
            return state.merge({
                isCardProcessing: false,
                cardProcessingError: fromJS(payload.errorMessage),
            })
        }

        case actions.CLEAR_CARD_ERROR: {
            return state.merge({
                cardProcessingError: null,
            })
        }

        case actions.GET_SAVED_CARDS: {
            return state.merge({
                getCardsInProgress: true,
            })
        }

        case actions.GET_SAVED_CARDS_SUCCESS: {
            return state.merge({
                getCardsInProgress: false,
                cardProcessingError: null,
                cards: fromJS(payload),
            })
        }

        case actions.GET_SAVED_CARDS_FAILED: {
            return state.merge({
                getCardsInProgress: false,
            })
        }

        case actions.SELECT_CARD: {
            return state.merge({
                selectedCard: fromJS(payload),
            })
        }

        case actions.DEFAULT_CARD: {
            return state.merge({
                defaultCard: fromJS(payload),
                selectedCard: null,
            })
        }

        case actions.RESET_WALLET: {
            return state.merge({
                defaultCard: null,
                cards: List([]),
                cardLinkedToSubscription: null,
                isCardProcessing: false,
                getCardsInProgress: false,
                cardProcessingError: null,
                selectedCard: null,
            })
        }

        case actions.ADD_PAYPAL_PAYMENT_METHOD: {
            return state.merge({
                isPaypalProcessing: true,
            })
        }

        case actions.ADD_PAYPAL_PAYMENT_METHOD_SUCCESS: {
            return state.merge({
                isPaypalProcessing: false,
            })
        }

        case actions.ADD_PAYPAL_PAYMENT_METHOD_FAILED: {
            return state.merge({
                isPaypalProcessing: false,
            })
        }

        case actions.SET_LAST_SUBSCRIPTION_RENEWAL_DATE: {
            return state.merge({
                lastSubscriptionRenewalDate: payload,
            })
        }

        case actions.SET_CARD_LINKED_TO_SUBSCRIPTION: {
            return state.merge({
                cardLinkedToSubscription: payload,
            })
        }

        default:
            return state
    }
}

export default wallet
